import { z } from "zod";

export const addressSearchQuerySchema = z
	.object({
		q: z.string().min(3, { message: "Query must be at least 3 characters" }),
		limit: z.coerce.number().int().min(1).max(10).default(5),
	})
	.strict();

export type AddressSearchQueryPayload = z.infer<typeof addressSearchQuerySchema>;

export interface AddressSuggestion {
	label: string;
	latitude: number;
	longitude: number;
}
